import React, {createContext, useContext, useState, useEffect} from "react";

const DarkModeContext = createContext({darkMode: false, toggleDarkMode: () => {}});

// Single source of truth for dark mode — was previously duplicated as local
// state in Navbar with no way for anything else (like a MUI theme) to react
// to it. Also keeps toggling body's `dark-mode` class in sync, which the
// app's own (non-MUI) stylesheets key off of — see index.css, Orders.css,
// Containers/Deliverers/styles.css.
export function DarkModeProvider({children}) {
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem('darkMode') === 'true');

  useEffect(() => {
    document.body.classList.toggle('dark-mode', darkMode);
  }, [darkMode]);

  const toggleDarkMode = () => {
    setDarkMode((prev) => {
      const next = !prev;
      localStorage.setItem('darkMode', `${next}`);
      return next;
    });
  };

  return (
    <DarkModeContext.Provider value={{darkMode, toggleDarkMode}}>
      {children}
    </DarkModeContext.Provider>
  );
}

export const useDarkMode = () => useContext(DarkModeContext);
